var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurementFlatArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 499 205.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.5,205.6H10.95c-4.16,0-7.96-2.36-9.81-6.08-1.85-3.73-1.42-8.18,1.09-11.49L141.78,4.33c2.07-2.73,5.29-4.33,8.72-4.33H488.05c4.16,0,7.96,2.36,9.81,6.08,1.85,3.73,1.42,8.18-1.09,11.49l-139.55,183.71c-2.07,2.73-5.29,4.33-8.72,4.33ZM33.01,183.71H343.07L465.99,21.9H155.93L33.01,183.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementFlatArea);
export default __webpack_public_path__ + "static/media/measurementFlatArea.290483a69a168c772b1638d0a6240bef.svg";
export { ForwardRef as ReactComponent };